module.exports = __webpack_public_path__ + "img/43.c6059f00.jpg";